import {Component, ElementRef, HostListener, OnInit} from '@angular/core';
import {SystemConfigurationService} from '../../lib/services/system-configuration/system-configuration.service';
import {ResetPasswordService} from "../../lib/services/reset-password/reset-password.service";
import {SystemAuthenticationService} from "@monex-sistemas/nueva-banca-digital-library";
import {UserUtilsService} from "../../lib/services/user/user-utils.service";
import * as pubsub from "pubsub-js";
import {firstValueFrom} from "rxjs";
import {TranslateService} from "@ngx-translate/core";
import {ValidateRsaTokenService} from "../../lib/services/validate-rsa-token/validate-rsa-token.service";
import {LoadingService} from "../../lib/services/loading/loading.service";
import {ModalsService} from "../../lib/services/modals/modals.service";
import {ToastService} from "../../lib/services/toast/toast.service";


const changePasswordPubsubEventName = "system-configuration-change-password-event"

@Component({
    selector: 'app-system-configuration',
    templateUrl: './system-configuration.component.html',
    styleUrls: ['./system-configuration.component.scss']
})
export class SystemConfigurationComponent implements OnInit {
    showConfigurationDialog: boolean = false;
    changePassSuccessModalShow = false;
    menuList: any[] = [
        {
            labelKey: "CHANGE_YOUR_PASSWORD",
            action: () => {
                this.openChangePasswordModal()
            },
            urlRedirect: ""
        },
        {
            labelKey: "PAYMENT_LIBERATION",
            action: () => {
                this.openPaymentRelease()
            },
            urlRedirect: ""
        }
    ];
    authChangePasswordModal = false;
    cveUser: any = "";
    translations;

    constructor(
        private systemConfigurationService: SystemConfigurationService,
        private elementRef: ElementRef,
        private resetPasswordService: ResetPasswordService,
        private systemAuthService: SystemAuthenticationService,
        private userUtils: UserUtilsService,
        private translationService: TranslateService,
        private validateRsaTokenService: ValidateRsaTokenService,
        private loadingService: LoadingService,
        private modalService: ModalsService,
        private toastService: ToastService
    ) {
        this.cveUser = String(userUtils.getPersonId())
    }

    ngOnInit() {
        this.changePasswordPubSubEvent();
        this.getTranslation()

    }

    @HostListener('document:click', ['$event'])
    onDocumentClick(event: MouseEvent): void {
        const clickedInside = this.elementRef.nativeElement.contains(event.target);
        if (!clickedInside && this.showConfigurationDialog) {
            this.showConfigurationDialog = false
        }
    }

    openConfiguration() {
        this.showConfigurationDialog = true
    }

    openPaymentRelease() {
        this.systemConfigurationService.open()
    }

    openChangePasswordModal() {
        this.authChangePasswordModal = true;
    }

    changePassword(event) {
        this.resetPasswordService.setPassword(event.currentPassword, event.password);
        this.authChangePasswordModal = false;
        this.systemAuthService.openValidationToken(changePasswordPubsubEventName)
    }


    async changePasswordPubSubEvent() {
        pubsub.subscribe(changePasswordPubsubEventName, async (msg: any, data: any) => {
            let tokenStatus = await this.validateRsaTokenService.validateRsaToken(this.translations.TOKEN_STATUS, data);
            if (tokenStatus) {
                this.loadingService.show();
                const errorMessage = this.translations.password.error
                this.resetPasswordService.changeAuthPassword(data.token, this.translations.password).subscribe({
                    next: (response:any) => {
                        if (response?.code == 1) {
                            //this.modalService.open([], "success", true, true, this.translations.password.success, undefined, 'sm')
                            this.changePassSuccessModalShow = true;
                        } else {
                            this.toastService.showToast(errorMessage)
                        }
                    },
                    error: err => {
                        this.toastService.showToast(errorMessage)
                    },
                    complete: () => {
                        this.loadingService.hide();
                    }
                })

            }
        })
    }

    async getTranslation() {
        this.translations = await firstValueFrom(this.translationService.get([
            "TOKEN_STATUS",
            "password"
        ]))
    }

    closeChangeModalPassword() {
        this.authChangePasswordModal = false;
    }

    onCloseChangePassSuccess() {
        this.changePassSuccessModalShow = false;

    }

}
